import React from 'react';
import Timer from "../../Timer/container/Timer"
import ProgressInfo from "../../../components/ProgressInfo";
import GameOver from "../../../components/GameOver";
import CountDown from "../../../components/CountDown";
import StartOverlay from "components/StartOverlay";
import Grid from "./Grid"
import { connect } from 'react-redux'
import { NAME as WORD_PAIRS_NAME } from '../reducer'
import { bindActionCreators } from 'redux'
import { actions as wordPairsContainerActions } from '../actions'
import { CSSTransition } from "react-transition-group";
import { strings } from "../../../constants/strings";
import WordPairsImg from "../../../assets/images/exercises/wordpairs_preex.svg";
import { analyticsActions } from "constants/analytics-actions-id";

const INFINITY = 2000000000

function mapStateToProps(state) {
  return {
    ...state[WORD_PAIRS_NAME]
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...wordPairsContainerActions,
  dispatch
}, dispatch)

class WordPairs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startOverlayTransitionIsFinished: false,
      progressInfoTransitionIsFinished: false
    }
  }

  componentWillUnmount() {
    
  }

  render() {
    if (this.props.exersizeState === 'gameOver') {
      this.timer = setTimeout(() => {
        this.props.dispatch({ type: "SHOW_GAME_OVER_SCREAN" });
      }, 1200);
    }
    return (
      <div className='App exercise-container'>
        <CSSTransition
          in={this.props.exersizeState === 'startScrean'}
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
          onExited = {()=>this.setState({startOverlayTransitionIsFinished: true})}
        >
          <StartOverlay
            img={WordPairsImg}
            name={strings.WordPairs_name}
            title={strings.WordPairs_title}
            description={strings.WordPairs_description}
            btnText={strings.OverlayView_btn_start}
            btnId={this.props.initial?analyticsActions.WordPairsInitial.btnStart:analyticsActions.WordPairs.btnStart}           
            onClick={() => { this.props.startPreExersize() }}
          />
        </CSSTransition>
        <CSSTransition
          in={this.props.exersizeState === 'scoreScrean' && this.state.progressInfoTransitionIsFinished}
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
        >
          {this.props.gameOverComponent ? (
            this.props.gameOverComponent({
              title: strings.WordPairs_name,
              points: this.props.points,
            })
          ) : (
            <GameOver
              title={strings.WordPairs_name}
              points={this.props.points}
              analyticsActions={this.props.initial?analyticsActions.WordPairsInitial:analyticsActions.WordPairs}
            />
          )}
        </CSSTransition>
        <CSSTransition
          in={
            (
            this.props.exersizeState === 'preexersize' || 
            this.props.exersizeState === 'gameStarted' || 
            this.props.exersizeState === 'gameOver'
            ) && this.state.startOverlayTransitionIsFinished
          }
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
          onExited = {()=>this.setState({progressInfoTransitionIsFinished: true})}    
        >   
              
            <ProgressInfo
              timeLeft={this.props.timeLeft}
              points={this.props.points}
              name={strings.WordPairs_name}
              title={strings.WordPairs_title}
              game={
                <>
                  <Timer
                    started={this.props.exersizeState === 'preexersize'}
                    increment={this.props.incrementCountDown}
                    interval={1000}
                    incrementCounter={this.props.countDown}
                    timerFinished={this.props.startGame }
                  />
                  <Timer
                    started={this.props.exersizeState === 'gameStarted'}
                    increment={this.props.increment}
                    interval={1000}
                    incrementCounter={this.props.timeLeft}
                    timerFinished={ this.props.gameOverAction }
                  />
                  <CountDown key="countDown" countDown={this.props.countDown} />
                  <Grid
                    exName="letter-search"
                    key="grid"
                    exersizeState={this.props.exersizeState}
                    onCellClick={ this.props.cellClickAction }
                  />
                </>
              }
            >
              <div className="col-md-6 col-sm-6">
                {strings.SLMB_remaining}{" "}
                <span className="value">
                  {this.props.leftToFind}
                </span>
              </div>
            </ProgressInfo>
        </CSSTransition>
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(WordPairs)
